import React from 'react';
import { getFlexibleSize } from '@utils/cssHelpers';
import ResourcesList from '@shared/Resources/shared/components/ResourcesList';
import { getDateDisplay } from '@shared/Resources/shared/components/ListWrappers';
import { listInnerEntityNameHelper } from '@shared/Resources/helpers';
import { useTranslation } from 'react-i18next';

const MentorFormList = (props) => {
  const { t } = useTranslation();
  const tableConf = [
    {
      getDisplay: (item) => listInnerEntityNameHelper(item, t),
      name: t('Common.UI.name'),
      textOptions: {
        size: 'H4',
        color: 'DARK_BLUE',
        withEllipsis: true,
      },
    },
    {
      getDisplay: (item) => getDateDisplay(item.entityCreated),
      name: t('Common.UI.created'),
      textOptions: {
        withEllipsis: true,
      },
      width: getFlexibleSize(95, 140),
    },
    {
      getDisplay: (item) => getDateDisplay(item.entityUpdated),
      name: t('Common.UI.modified'),
      textOptions: {
        withEllipsis: true,
      },
      width: getFlexibleSize(95, 120),
    },
  ];
  return <ResourcesList {...props} tableConf={tableConf} />;
};

export default MentorFormList;
